import { generateName, numCompare, roundDecimal } from "@common/Common";
import { AlternativeAttributeValueChangeReadModel, AlternativeReadModel, AttributeReadModel, CriterionReadModel } from "@Evaluation/ValueAnalysis/Domain/readmodels";

export class SaveToAttributeDialogViewModel
{
    opened: boolean = false;
    saving: boolean = false;

    step: string = "start";

    defaultName: string = null;
    changes: AlternativeAttributeValueChangeReadModel[] | null = null;
    scoreSaver: boolean = null;

    newAttributeName: string | null = null;

    useExistingAttribute: boolean = false;
    existingAttribute: AttributeReadModel | null = null;


    alternatives: AlternativeReadModel[] = [];
    selectedCriterion: CriterionReadModel | null = null;
    precision: number = 3;
    attributes: AttributeReadModel[] = [];

    showScoreSaver(selectedCriterion: CriterionReadModel, alternatives: AlternativeReadModel[], precision: number, attributes: AttributeReadModel[])
    {
        this.selectedCriterion = selectedCriterion;
        this.alternatives = alternatives;
        this.precision = precision;
        this.attributes = attributes;

        this.newAttributeName = generateName(`${this.selectedCriterion.Name} score`);
        this.useExistingAttribute = false;
        this.existingAttribute = null;
        this.changes = null;

        this.scoreSaver = true;
        this.step = "start";  
        this.opened = true;
    }

    showRankSaver(selectedCriterion: CriterionReadModel, alternatives: AlternativeReadModel[], precision: number, attributes: AttributeReadModel[])
    {
        this.selectedCriterion = selectedCriterion;
        this.alternatives = alternatives;
        this.precision = precision;
        this.attributes = attributes;

        this.newAttributeName = generateName(`${this.selectedCriterion.Name} rank position`);
        this.useExistingAttribute = false;
        this.existingAttribute = null;
        this.changes = null;

        this.scoreSaver = false;
        this.step = "start";  
        this.opened = true;
    }

    showChanges(attributeId: number | null)
    {
        if (this.scoreSaver === true)
        {
            this.changes = this.alternatives.map(alternative => 
            {
                return {
                    Id: alternative.Id,
                    Name: alternative.Name,
                    NewValue: roundDecimal(alternative.Criteria.find(v => v.CriterionId === this.selectedCriterion.Id)?.Value, this.precision),
                    OldValue: attributeId ? alternative.Attributes.find(v => v.AttributeId === attributeId)?.Value : null,
                };
            }).sort((a, b) => numCompare(a.NewValue, b.NewValue)).reverse();
        }
        else
        {
            this.changes = this.alternatives.map(alternative => 
            {
                return {
                    Id: alternative.Id,
                    Name: alternative.Name,
                    NewValue: alternative.Criteria.find(v => v.CriterionId === this.selectedCriterion.Id)?.Rank,
                    OldValue: attributeId ? alternative.Attributes.find(v => v.AttributeId === attributeId)?.Value : null,
                };
            }).sort((a, b) => numCompare(a.NewValue, b.NewValue));
        }
    }


    saveExistingAttribute(attributeId: number)
    {
        alert(attributeId);
    }

    close()
    {
        this.opened = false;
    }
}